export default {
    phoneCountryCode: '34',
};
